import Vue from 'vue';
import Vuex from 'vuex'
import { IDataImportAutosaveBlob } from './IDataImportAutosaveBlob';
import ImportModule from './ImportModule';

Vue.use(Vuex)

export interface IState {
  importDetails: IDataImportAutosaveBlob;
}

export default new Vuex.Store<IState>({
  modules: {
    importDetails: ImportModule
  }
})